export const application = window._env_.APPLICATION_NAME || 'dlz';

export const baseURL = window._env_.BASE_URL;

export const redirectBaseURL = window._env_.REDIRECT_BASE_URL;

// mh-ld-web
export const apiURL = window._env_.API_URL;

// cmdb-backend
export const cmdbURL = window._env_.CMDB_API_URL;

export const logoutEnabled = Boolean(window._env_.DLZ_LOGOUT_ENABLED);

export const idleTimeWarnLogout = process.env.IDLE_TIME_WARN_LOGOUT
  ? Number(process.env.IDLE_TIME_WARN_LOGOUT)
  : 1000 * 60 * 14;

export const idleTimeLogout = process.env.IDLE_TIME_LOGOUT
  ? Number(process.env.IDLE_TIME_LOGOUT)
  : idleTimeWarnLogout + 1000 * 60 * 1;

export const gaId = window._env_.GA_ID;

export const disableGA = window._env_.DISABLE_GA === 'true';
